import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import { memo } from "react";
import { Tooltip } from "@mui/material";
import AccountMenu from "../AccountMenu/AccountMenu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PropTypes from "prop-types";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import CampaignIcon from "@mui/icons-material/Campaign";
import "./style.css";
import Announcment from "../../Text-to-speech/announcment";
import feedback_icon from "../../../Assets/svgs/feedback_icon.svg"
import tutorial_icon from "../../../Assets/svgs/tutorial_icon.svg";
import SubmitFeedback from "../../Feedback/Feedback";
import ReactPlayer from "react-player";
import Modal from "../../Modal";


function ResponsiveAppBar({ handletoggle }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isAnnouncment, setisAnnouncment] = React.useState(false);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const [openFeedbackModal, setOpenFeedbackModal] = React.useState(false);
  const [openTutorialModal, setOpenTutorialModal] = React.useState(false);


  const showTutorialVideo = () => {
    return (
      <ReactPlayer

        // url={
        // "https://6392938d3120a.streamlock.net:8081/vod/default/tour_guide_video_clips/tour_guide_video_for_application_1.mp4/playlist.m3u8"
        // }
        url = {"https://bbcontent.nayatel.com/content/tour_guide_video_clips/boostboard_demo.mp4"}
        height="100%"
        width="100%"
        playing
        muted={true}
        loop={true}
        controls={true}
        onError={e => { console.log(e);} }
      />
    );
  }


  const handleTutorialVideo = (event) => {
    console.log("here");
    setOpenTutorialModal(true);
  }

  const handleTutorialClick = (event) => {
    setOpenTutorialModal(false);
  }
  const handleClick = (event) => {

    setOpenFeedbackModal(true);
    // setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    // setAnchorEl(null);
    setOpenFeedbackModal(false);

  };

  return (
    <Box sx={{ flexGrow: 1, mr: 3 }}>
      <AccountMenu
        anchorEl={anchorEl}
        handleClick={handleClick}
        handleClose={handleClose}
        open={open}
      />
      <AppBar
        position="static"
        sx={{ borderRadius: 2 }}
        style={{
          backgroundColor: "#FFFFFF",
          color: "#000",
          boxShadow: "rgba(149, 157, 165, 0.1) 0px 8px 8px",
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2, display: { md: "none", lg: "none" } }}
            onClick={() => handletoggle()}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              display: { xs: "none", sm: "none", md: "block", lg: "block" },
            }}
          >
            Hey, Welcome to Boost Board
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              size="large"
              aria-label="show 4 new mails"
              color="inherit"
              disableRipple
              sx={{ cursor: "default" }}
            >
              {/* <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{
                  display: { xs: "none", sm: "none", md: "block", lg: "block" },
                }}
              >
                {localStorage.getItem("txt_customer_id")}
              </Typography> */}
            </IconButton>
          </Box>
          <Box>
            {/* <Tooltip title="Announcement"> */}
              {/* <IconButton
                size="large"
                aria-label="Announcement"
                color="inherit"
                onClick={() => setisAnnouncment(true)}
                className="announcement"
              >
                <CampaignIcon />
              </IconButton> */}
            {/* </Tooltip>  */}
            <Tooltip title="Demo">
              <IconButton
                size="large"
                aria-label="show demo"
                color="inherit"
                onClick={handleTutorialVideo}
              >
                <img src={tutorial_icon} alt="Tutorial Icon"></img>
              </IconButton>
            </Tooltip>


            <Tooltip title="Submit Feedback">
            <IconButton
              size="large"
              aria-label="show profile"
              color="inherit"
              onClick={handleClick}
              // aria-controls={open ? "account-menu" : undefined}
              // aria-haspopup="true"
              // aria-expanded={open ? "true" : undefined}
            >
              <img src={feedback_icon} alt="Feedback Icon"></img>
              {/* <KeyboardArrowDownIcon /> */}
            </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>
      {/* {isAnnouncment ? (
        <Announcment
          isAnnouncment={isAnnouncment}
          closeAnnouncmentModal={() => setisAnnouncment(false)}
        />
      ) : null} */}


          {openTutorialModal ? (
            <Modal open={openTutorialModal} onCloseModal={handleTutorialClick} padding={false} closeicon ={true} closeOnEsc={true}>
              {showTutorialVideo()}
            </Modal>
          ) : null}

<SubmitFeedback
          openFeedBackModal={openFeedbackModal}
          onCloseModal={handleClose}
        />
    </Box>
  );
}

ResponsiveAppBar.propTypes = {
  handletoggle: PropTypes.func,
};

export default memo(ResponsiveAppBar);
